import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from "@mui/material";
import { colors } from "@components/ui/colors";

export const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  description = "Are you sure you want to perform this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  stopPropagation = false,
  loading = false,
}) => {
  const stopEvent = (event) => {
    if (!stopPropagation) return;

    event?.preventDefault?.();
    event?.stopPropagation?.();
  };

  const handleCancel = (event) => {
    stopEvent(event);
    onCancel?.();
  };

  const handleConfirm = async (event) => {
    stopEvent(event);

    await onConfirm?.();
    onCancel?.();
  };

  return (
    <Dialog
      open={open}
      onClose={(event) => {
        stopEvent(event);
        onCancel?.();
      }}
      onClick={stopEvent}
      onMouseDown={stopEvent}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: 999999999 }}
      PaperProps={{
        onClick: stopEvent,
        onMouseDown: stopEvent,
        sx: {
          borderRadius: 3,
          boxShadow: "0 18px 45px rgba(0, 0, 0, 0.18)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{
          px: 3,
          pt: 3,
          pb: 1,
          fontSize: 20,
          fontWeight: 700,
          color: "var(--fx-surface-text, #0F172A)",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 2 }}>
        <DialogContentText
          id="confirm-dialog-description"
          sx={{
            fontSize: 14,
            lineHeight: 1.6,
            color: "var(--fx-surface-textsecondary, #64748B)",
          }}
        >
          {description}
        </DialogContentText>
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          gap: 1,
          backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
        }}
      >
        <Button
          onClick={handleCancel}
          onMouseDown={stopEvent}
          disabled={loading}
          sx={{
            minWidth: 100,
            height: 38,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            color: "var(--fx-surface-textsecondary, #64748B)",
            border: "1px solid var(--fx-surface-borderstrong, #CBD5E1)",
            backgroundColor: "var(--fx-surface-base, #FFFFFF)",
            "&:hover": {
              backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
              borderColor: "var(--fx-surface-texttertiary, #94A3B8)",
            },
          }}
        >
          {cancelText}
        </Button>

        <Button
          onClick={handleConfirm}
          onMouseDown={stopEvent}
          disabled={loading}
          sx={{
            minWidth: 120,
            height: 38,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 700,
            color: "#fff",
            boxShadow: "none",
            backgroundColor: colors.orange.base,
            "&:hover": {
              backgroundColor: colors.orange[600],
              boxShadow: "none",
            },
            "&.Mui-disabled": {
              backgroundColor: "#d1d5db",
              color: "var(--fx-surface-textsecondary, #64748B)",
            },
          }}
        >
          {loading ? "Processing..." : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
